import React from 'react';
import { getData, deleteData, }  from '../../../core/HttpAction';
import Table from '../../../core/Table'; 
import Filter from './../Student/Filter';
import {Link} from 'react-router-dom';

const Url='/student-fees';

const CellCourse=({row})=>{  
    return<span>{row.feesData[0].course}</span>;
};
const CellYearSemester=({row})=>{  
    return<span>{row.feesData[0].courseyear}({row.feesData[0].courseYearSemester})</span>;
};

const CellColumn=({props,row})=>{
    return row.fees_status==2?<Link to={`student-fees-due/${row.student_fees_id}`}><span className="uk-badge">Pay</span></Link>:'--';
};

const columns=[
    {
        key:'student_name',
        displayName:'Student Name'
    },
    {
        key:'course_name',
        displayName:'Course',
        Cell:CellCourse,
    },
    {
        key:'courseyear',
        displayName:'Year(Semester)', 
        Cell:CellYearSemester,
    }, 
    {
        key:'bill_amount',
        displayName:'Bill Amount'
    },
    /* {
        key:'cash',
        displayName:'Cash'
    },
    {
        key:'dd_rtgs',
        displayName:'RTGS Amount'
    }, 
    {
        key:'dd_amount',
        displayName:'DD Amount'
    }, 
    {
        key:'fg_scholar_amount',
        displayName:'F.G Amount'
    },
    {
        key:'other_scholar_amount',
        displayName:'O.S Amount'
    }, */
    {
        key:'amount_paid',
        displayName:'Amount Paid'
    },
    {
        key:'excess_amount',
        displayName:'Excess Amount'
    },
    {
        key:'balance_amount',
        displayName:'Due Amount'
    },
    {
        key:'balance_amount',
        displayName:'Pay Due',
        Cell:CellColumn,
    },
    {
        key:'status',
        displayName:'Status'
    }
];       
class UserType extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            params:{
                search_term: '',
                startDate: '',
                endDate:'', 
                course_id:'',
                course_quota:'',
                course_year_id:'',
                other_scholarship:'',
                graduation:'', 
                limit:10,
                page:1
            }, 
            data:[],
            preloader:true,
        };
        this.fetchData = this.fetchData.bind(this);  
        this.handleFetch = this.handleFetch.bind(this);  
        this.delete = this.delete.bind(this);  
    }
 
    componentDidMount(){
        this.fetchData();
    }

 
    fetchData(){
        getData(Url,this.state.params).then((res)=>{ 
            this.setState({data:res.data,preloader:false}); 
        });
    }

    handleFetch(params){
        this.setState({params:{...this.state.params,...params},preloader:true},()=>{
            this.fetchData();
        });
    }

    delete(id){
        let page=1;
        this.setState({preloader:true,params:{...this.state.params,page}});
        deleteData(Url+'/'+id).then((res)=>{
            if(res.data.status===200){
                this.fetchData();
            }else{
                alert('Not delete');
                this.setState({preloader:false});
            }
        });   
    }
    
    custonAction=(data)=> {  
        this.setState({params:{...this.state.params,...data},preloader:true},()=>{
            this.fetchData();
        }); 
    }


    render() {

        let {preloader,data}=this.state; 

        return (
            <Table
                data={data}
                handleFetch={this.handleFetch.bind(this)}
                preloader={preloader}
                permission="student-fees"
                title="Student Fees"
                columns={columns}
                primaryKey="student_fees_id"
                addEditUrl="student-fees-action" 
                delete={this.delete.bind(this)}
                custonAction={this.custonAction}
                CustomFilters={ Filter }
            /> 
        );
    }
}
 

export default UserType;



// WEBPACK FOOTER //
// ./src/components/Student/StudentFees/index.js